import { render, staticRenderFns } from "./Teachersviewdetails.vue?vue&type=template&id=f0a0f5a6&scoped=true&"
import script from "./Teachersviewdetails.vue?vue&type=script&lang=js&"
export * from "./Teachersviewdetails.vue?vue&type=script&lang=js&"
import style0 from "./Teachersviewdetails.vue?vue&type=style&index=0&id=f0a0f5a6&scoped=true&lang=css&"
import style1 from "./Teachersviewdetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a0f5a6",
  null
  
)

export default component.exports